module.exports = __webpack_public_path__ + "static/img/bg3.50182804.jpeg";